export const languageElements = {
  items: {
    "flush-filter": {
      hu: "Adatok előszűrése",
      de: "Daten filtern",
      en: "Filtering data",
    },

    "flush-data": {
      hu: "Fuvarjaim",
      de: "Fracht Journal",
      en: "Freight list",
    },

    'field-ExternalSystem_TransactID': {
      hu: 'External System Transact ID',
      de: 'External System Transact ID',
      en: 'External System Transact ID',
    },

    "field-Pozicioszam": {
      hu: "Pozíciószám",
      de: "Sendungsnummer",
      en: "Job number",
    },

    "field-Megbizo": {
      hu: "Megbízó",
      de: "Kunde",
      en: "Customer",
    },

    "field-Megrendelesszam": {
      hu: "Megrendelésszám",
      de: "Bestellnummer",
      en: "PO number",
    },

    "field-Status": {
      hu: "Státusz",
      de: "Status",
      en: "Track & trace status",
    },

    "status-registered": {
      hu: "Rögzítve",
      de: "Registered",
      en: "Registered",
    },

    "status-finished": {
      hu: "Befejezve",
      de: "Finished",
      en: "Finished",
    },

    "status-cancelled": {
      hu: "Sztornó",
      de: "Cancelled",
      en: "Cancelled",
    },

    "field-Felrakohely": {
      hu: "Felrakóhely",
      de: "Beladestelle",
      en: "Loading point",
    },

    "field-Felrakohely_Iranyitoszam": {
      hu: "Felrakóhely - irányítószám",
      de: "Beladestelle - PLZ",
      en: "Loading point - zipcode",
    },

    "field-Felrakohely_Varos": {
      hu: "Felrakóhely - város",
      de: "Beladestelle - Ort",
      en: "Loading point - city",
    },

    "field-Felrakohely_Cim": {
      hu: "Felrakóhely - cím",
      de: "Beladestelle - Adresse",
      en: "Loading point - address",
    },

    "field-Felrakas_datuma": {
      hu: "Felrakás dátuma",
      de: "Beladedatum",
      en: "Date of loading",
    },

    "field-Lerakohely": {
      hu: "Lerakóhely",
      de: "Entladestelle",
      en: "Delivery",
    },

    "field-Lerakohely_Iranyitoszam": {
      hu: "Lerakóhely - irányítószám",
      de: "Entladestelle - PLZ",
      en: "Delivery - zipcode",
    },

    "field-Lerakohely_Varos": {
      hu: "Lerakóhely - város",
      de: "Entladestelle - Ort",
      en: "Delivery - city",
    },

    "field-Lerakohely_Cim": {
      hu: "Lerakóhely - cím",
      de: "Entladestelle - Adresse",
      en: "Delivery - address",
    },

    "field-Lerakas_datuma": {
      hu: "Lerakás dátuma",
      de: "Entladedatum",
      en: "Date of delivery",
    },

    "field-hasDocuments": {
      hu: "Dokumentumok feltöltve",
      de: "Beigefügte Dokumente",
      en: "Attached documents",
    },
  },
};
